import { Contract, Order } from '@codegen';
import {
  ContractsActions,
  ContractsTypes,
} from '@modules/order/store/contracts/contracts.action';

export class ContractsState {
  public contractsList: Contract[] = [];
  public contractDetails: Contract | null;
  public productsList: Order;
  public archivalContractsList: Contract[] = [];
  public activeRouteLink: string;
}

export function reducer(
  state = new ContractsState(),
  action: ContractsActions
): ContractsState {
  switch (action.type) {
    case ContractsTypes.SetContractsList:
      return {
        ...state,
        contractsList: action.payload,
      };
    case ContractsTypes.SetContractDetails:
      return {
        ...state,
        contractDetails: action.payload,
      };
    case ContractsTypes.SetProducts:
      return {
        ...state,
        productsList: action.payload,
      };
    case ContractsTypes.SetArchivalContractsList:
      return {
        ...state,
        archivalContractsList: action.payload,
      };
    case ContractsTypes.SetActiveContractRouteLink:
      return {
        ...state,
        activeRouteLink: action.payload,
      };
    default: {
      return state;
    }
  }
}
